import {css} from 'lit';

const blue = css`
:root {
  --cre8-desktop-menu-padding-vertical-padding: 1rem;
  --cre8-desktop-menu-padding-horizontal-padding: 0.5rem;
  --cre8-color-header-bg-default: #ffffff;
  --cre8-color-header-inverse-bg-default: #1a73e8;
  --cre8-color-header-menu-bg-default: #ffffff;
  --cre8-color-header-menu-inverse-bg-default: #1a73e8;
  --cre8-color-header-menu-bg-hover: #f6f5f3;
  --cre8-color-header-menu-inverse-bg-hover: #0d47a1;
  --cre8-color-header-menu-bg-focus: #f6f5f3;
  --cre8-color-header-menu-inverse-bg-focus: #0d47a1;
  --cre8-color-header-menu-bg-active: #edebe7;
  --cre8-color-header-menu-inverse-bg-active: #0a3d8f;
  --cre8-color-header-menu-bg-pressed: #edebe7;
  --cre8-color-header-menu-inverse-bg-pressed: #0a3d8f;
  --cre8-color-header-menu-bg-selected: #f6f5f3;
  --cre8-color-header-menu-inverse-bg-selected: #0d47a1;
  --cre8-color-header-menu-content-default: #1a73e8;
  --cre8-color-header-menu-inverse-content-default: #ffffff;
  --cre8-color-header-menu-content-hover: #0d47a1;
  --cre8-color-header-menu-inverse-content-hover: #ffffff;
  --cre8-color-header-menu-content-focus: #1a73e8;
  --cre8-color-header-menu-inverse-content-focus: #ffffff;
  --cre8-color-header-menu-content-active: #0a3d8f;
  --cre8-color-header-menu-inverse-content-active: #ffffff;
  --cre8-color-header-menu-content-pressed: #0a3d8f;
  --cre8-color-header-menu-inverse-content-pressed: #ffffff;
  --cre8-color-header-menu-content-selected: #0d47a1;
  --cre8-color-header-menu-inverse-content-selected: #ffffff;
  --cre8-color-header-menu-border-default: rgba(45, 45, 45, 0.0);
  --cre8-color-header-menu-inverse-border-default: rgba(45, 45, 45, 0.0);
  --cre8-color-header-menu-border-hover: rgba(45, 45, 45, 0.0);
  --cre8-color-header-menu-inverse-border-hover: #ffffff;
  --cre8-color-header-menu-border-focus: #0d47a1;
  --cre8-color-header-menu-inverse-border-focus: #ffffff;
  --cre8-color-header-menu-border-active: #1a73e8;
  --cre8-color-header-menu-inverse-border-active: #ffffff;
  --cre8-color-header-menu-border-pressed: #1a73e8;
  --cre8-color-header-menu-inverse-border-pressed: #ffffff;
  --cre8-color-header-menu-border-selected: #0d47a1;
  --cre8-color-header-menu-inverse-border-selected: #f6f5f3;
  --cre8-color-header-submenu-bg-default: #ffffff;
  --cre8-color-header-submenu-inverse-bg-default: #1a73e8;
  --cre8-color-header-submenu-bg-hover: #f6f5f3;
  --cre8-color-header-submenu-inverse-bg-hover: #0d47a1;
  --cre8-color-header-submenu-bg-focus: #ffffff;
  --cre8-color-header-submenu-inverse-bg-focus: #1a73e8;
  --cre8-color-header-submenu-bg-active: #edebe7;
  --cre8-color-header-submenu-inverse-bg-active: #0a3d8f;
  --cre8-color-header-submenu-bg-pressed: #edebe7;
  --cre8-color-header-submenu-inverse-bg-pressed: #0a3d8f;
  --cre8-color-header-submenu-bg-selected: #f6f5f3;
  --cre8-color-header-submenu-inverse-bg-selected: #0d47a1;
  --cre8-color-header-submenu-content-default: #1a73e8;
  --cre8-color-header-submenu-inverse-content-default: #ffffff;
  --cre8-color-header-submenu-content-hover: #0d47a1;
  --cre8-color-header-submenu-inverse-content-hover: #ffffff;
  --cre8-color-header-submenu-content-focus: #0d47a1;
  --cre8-color-header-submenu-inverse-content-focus: #ffffff;
  --cre8-color-header-submenu-content-active: #0a3d8f;
  --cre8-color-header-submenu-inverse-content-active: #ffffff;
  --cre8-color-header-submenu-content-pressed: #0a3d8f;
  --cre8-color-header-submenu-inverse-content-pressed: #ffffff;
  --cre8-color-header-submenu-content-selected: #1a73e8;
  --cre8-color-header-submenu-inverse-content-selected: #ffffff;
  --cre8-color-header-submenu-border-default: #ffffff;
  --cre8-color-header-submenu-inverse-border-default: #1a73e8;
  --cre8-color-header-submenu-border-hover: #f6f5f3;
  --cre8-color-header-submenu-inverse-border-hover: #0d47a1;
  --cre8-color-header-submenu-border-focus: #1a73e8;
  --cre8-color-header-submenu-inverse-border-focus: #ffffff;
  --cre8-color-header-submenu-border-active: #edebe7;
  --cre8-color-header-submenu-inverse-border-active: #0a3d8f;
  --cre8-color-header-submenu-border-pressed: #edebe7;
  --cre8-color-header-submenu-inverse-border-pressed: #0a3d8f;
  --cre8-color-header-submenu-border-selected: #0d47a1;
  --cre8-color-header-submenu-inverse-border-selected: #f6f5f3;
  --cre8-color-header-bg-secondary: #1a73e8;
  --cre8-color-header-inverse-bg-secondary: #ffffff;
  --cre8-color-header-bg-tertiary: #1a73e8;
  --cre8-color-header-inverse-bg-tertiary: #ffffff;
  --cre8-color-footer-bg-default: #1a73e8;
  --cre8-color-footer-bg-secondary: #f6f5f3;
  --cre8-color-footer-content-secondary: #ffffff;
  --cre8-color-footer-link-hover: #0a3d8f;
  --cre8-color-footer-link-default: #0a3d8f;
  --cre8-spacing-0: 0rem;
  --cre8-spacing-2: 0.125rem;
  --cre8-spacing-4: 0.25rem;
  --cre8-spacing-6: 0.375rem;
  --cre8-spacing-8: 0.5rem;
  --cre8-spacing-12: 0.75rem;
  --cre8-spacing-14: 0.875rem;
  --cre8-spacing-16: 1rem;
  --cre8-spacing-18: 1.125rem;
  --cre8-spacing-24: 1.5rem;
  --cre8-spacing-32: 2rem;
  --cre8-spacing-40: 2.5rem;
  --cre8-spacing-48: 3rem;
  --cre8-spacing-64: 4rem;
  --cre8-spacing-80: 5rem;
  --cre8-spacing-96: 6rem;
  --cre8-spacing-120: 7.5rem;
  --cre8-spacing-160: 10rem;
  --cre8-button-padding-vertical-small: 0.5rem;
  --cre8-button-padding-vertical-large: 1rem;
  --cre8-button-padding-vertical-medium: 0.75rem;
  --cre8-button-padding-vertical-icon-only: 0.5rem;
  --cre8-button-padding-vertical-small-icon-only: 0.5rem;
  --cre8-button-padding-vertical-medium-icon-only: 1rem;
  --cre8-button-padding-vertical-large-icon-only: 1rem;
  --cre8-button-padding-horizontal-small: 1rem;
  --cre8-button-padding-horizontal-medium: 1.5rem;
  --cre8-button-padding-horizontal-large: 2rem;
  --cre8-button-padding-horizontal-icon-only: 0.5rem;
  --cre8-button-padding-horizontal-small-icon-only: 0.5rem;
  --cre8-button-padding-horizontal-medium-icon-only: 1rem;
  --cre8-button-padding-horizontal-large-icon-only: 1rem;
  --cre8-color-button-primary-bg: #1a73e8;
  --cre8-color-button-primary-inverse-bg: #e8eaf6;
  --cre8-color-button-primary-bg-hover: #0d47a1;
  --cre8-color-button-primary-inverse-bg-hover: #c5cae9;
  --cre8-color-button-primary-bg-active: #0a3d8f;
  --cre8-color-button-primary-inverse-bg-active: #9fa8da;
  --cre8-color-button-primary-bg-disabled: #eaeaea;
  --cre8-color-button-primary-inverse-bg-disabled: #ababab;
  --cre8-color-button-primary-content: #ffffff;
  --cre8-color-button-primary-inverse-content: #0d47a1;
  --cre8-color-button-primary-content-hover: #ffffff;
  --cre8-color-button-primary-inverse-content-hover: #0d47a1;
  --cre8-color-button-primary-content-active: #ffffff;
  --cre8-color-button-primary-inverse-content-active: #0d47a1;
  --cre8-color-button-primary-content-disabled: #949494;
  --cre8-color-button-primary-inverse-content-disabled: #6c6c6c;
  --cre8-color-button-primary-border: #1a73e8;
  --cre8-color-button-primary-inverse-border: #e8eaf6;
  --cre8-color-button-primary-border-hover: #0d47a1;
  --cre8-color-button-primary-inverse-border-hover: #c5cae9;
  --cre8-color-button-primary-border-active: #0a3d8f;
  --cre8-color-button-primary-inverse-border-active: #9fa8da;
  --cre8-color-button-primary-border-disabled: #eaeaea;
  --cre8-color-button-primary-inverse-border-disabled: #ababab;
  --cre8-color-button-primary-outline: #0a3d8f;
  --cre8-color-button-primary-inverse-outline: #e8eaf6;
  --cre8-color-button-primary-danger-bg: #d02525;
  --cre8-color-button-primary-danger-inverse-bg: #f88181;
  --cre8-color-button-primary-danger-bg-hover: #aa1313;
  --cre8-color-button-primary-danger-inverse-bg-hover: #f5a8a8;
  --cre8-color-button-primary-danger-bg-active: #7a0000;
  --cre8-color-button-primary-danger-inverse-bg-active: #fccaca;
  --cre8-color-button-primary-danger-bg-disabled: #eaeaea;
  --cre8-color-button-primary-danger-inverse-bg-disabled: #ababab;
  --cre8-color-button-primary-danger-content: #ffffff;
  --cre8-color-button-primary-danger-inverse-content: #2d2d2d;
  --cre8-color-button-primary-danger-content-hover: #ffffff;
  --cre8-color-button-primary-danger-inverse-content-hover: #2d2d2d;
  --cre8-color-button-primary-danger-content-active: #ffffff;
  --cre8-color-button-primary-danger-inverse-content-active: #2d2d2d;
  --cre8-color-button-primary-danger-content-disabled: #949494;
  --cre8-color-button-primary-danger-inverse-content-disabled: #6c6c6c;
  --cre8-color-button-primary-danger-border: #d02525;
  --cre8-color-button-primary-danger-inverse-border: #f88181;
  --cre8-color-button-primary-danger-border-hover: #aa1313;
  --cre8-color-button-primary-danger-inverse-border-hover: #f5a8a8;
  --cre8-color-button-primary-danger-border-active: #7a0000;
  --cre8-color-button-primary-danger-inverse-border-active: #fccaca;
  --cre8-color-button-primary-danger-border-disabled: #eaeaea;
  --cre8-color-button-primary-danger-inverse-border-disabled: #ababab;
  --cre8-color-button-primary-danger-outline: #0a3d8f;
  --cre8-color-button-primary-danger-inverse-outline: #e8eaf6;
  --cre8-color-button-secondary-neutral-bg: rgba(45, 45, 45, 0.0);
  --cre8-color-button-secondary-neutral-inverse-bg: rgba(45, 45, 45, 0.0);
  --cre8-color-button-secondary-neutral-content: #2d2d2d;
  --cre8-color-button-secondary-neutral-inverse-content: #ffffff;
  --cre8-color-button-secondary-neutral-border: #2d2d2d;
  --cre8-color-button-secondary-neutral-inverse-border: #ffffff;
  --cre8-color-button-secondary-neutral-bg-hover: rgba(45, 45, 45, 0.10);
  --cre8-color-button-secondary-neutral-inverse-bg-hover: rgba(45, 45, 45, 0.20);
  --cre8-color-button-secondary-neutral-content-hover: #2d2d2d;
  --cre8-color-button-secondary-neutral-inverse-content-hover: #ffffff;
  --cre8-color-button-secondary-neutral-border-hover: #2d2d2d;
  --cre8-color-button-secondary-neutral-inverse-border-hover: #ffffff;
  --cre8-color-button-secondary-neutral-border-active: #2d2d2d;
  --cre8-color-button-secondary-neutral-inverse-border-active: #ffffff;
  --cre8-color-button-secondary-neutral-bg-active: rgba(45, 45, 45, 0.20);
  --cre8-color-button-secondary-neutral-inverse-bg-active: rgba(45, 45, 45, 0.50);
  --cre8-color-button-secondary-neutral-content-active: #2d2d2d;
  --cre8-color-button-secondary-neutral-inverse-content-active: #ffffff;
  --cre8-color-button-secondary-neutral-bg-disabled: #eaeaea;
  --cre8-color-button-secondary-neutral-inverse-bg-disabled: #ababab;
  --cre8-color-button-secondary-neutral-border-disabled: #eaeaea;
  --cre8-color-button-secondary-neutral-inverse-border-disabled: #ababab;
  --cre8-color-button-secondary-neutral-content-disabled: #949494;
  --cre8-color-button-secondary-neutral-inverse-content-disabled: #6c6c6c;
  --cre8-color-button-secondary-neutral-outline: #1a73e8;
  --cre8-color-button-secondary-neutral-inverse-outline: #e8eaf6;
  --cre8-color-button-secondary-bg: rgba(45, 45, 45, 0.0);
  --cre8-color-button-secondary-inverse-bg: rgba(45, 45, 45, 0.0);
  --cre8-color-button-secondary-bg-hover: #ffffff;
  --cre8-color-button-secondary-inverse-bg-hover: rgba(45, 45, 45, 0.0);
  --cre8-color-button-secondary-bg-active: #e3f2fd;
  --cre8-color-button-secondary-inverse-bg-active: #0a3d8f;
  --cre8-color-button-secondary-bg-disabled: #eaeaea;
  --cre8-color-button-secondary-inverse-bg-disabled: rgba(45, 45, 45, 0.0);
  --cre8-color-button-secondary-content: #1a73e8;
  --cre8-color-button-secondary-inverse-content: #e8eaf6;
  --cre8-color-button-secondary-content-hover: #0d47a1;
  --cre8-color-button-secondary-inverse-content-hover: #c5cae9;
  --cre8-color-button-secondary-content-active: #0a3d8f;
  --cre8-color-button-secondary-inverse-content-active: #9fa8da;
  --cre8-color-button-secondary-content-disabled: #949494;
  --cre8-color-button-secondary-inverse-content-disabled: #ababab;
  --cre8-color-button-secondary-border: #1a73e8;
  --cre8-color-button-secondary-inverse-border: #e8eaf6;
  --cre8-color-button-secondary-border-hover: #0d47a1;
  --cre8-color-button-secondary-inverse-border-hover: #c5cae9;
  --cre8-color-button-secondary-border-active: #0a3d8f;
  --cre8-color-button-secondary-inverse-border-active: #9fa8da;
  --cre8-color-button-secondary-border-disabled: #ababab;
  --cre8-color-button-secondary-inverse-border-disabled: #ababab;
  --cre8-color-button-secondary-outline: #0a3d8f;
  --cre8-color-button-secondary-inverse-outline: #c5cae9;
  --cre8-color-button-secondary-danger-bg: rgba(45, 45, 45, 0.0);
  --cre8-color-button-secondary-danger-inverse-bg: rgba(45, 45, 45, 0.0);
  --cre8-color-button-secondary-danger-bg-hover: #aa1313;
  --cre8-color-button-secondary-danger-inverse-bg-hover: #f5a8a8;
  --cre8-color-button-secondary-danger-bg-active: #7a0000;
  --cre8-color-button-secondary-danger-inverse-bg-active: #fccaca;
  --cre8-color-button-secondary-danger-bg-disabled: #eaeaea;
  --cre8-color-button-secondary-danger-inverse-bg-disabled: #ababab;
  --cre8-color-button-secondary-danger-content: #d02525;
  --cre8-color-button-secondary-danger-inverse-content: #ff5c5c;
  --cre8-color-button-secondary-danger-content-hover: #ffffff;
  --cre8-color-button-secondary-danger-inverse-content-hover: #2d2d2d;
  --cre8-color-button-secondary-danger-content-active: #ffffff;
  --cre8-color-button-secondary-danger-inverse-content-active: #2d2d2d;
  --cre8-color-button-secondary-danger-content-disabled: #949494;
  --cre8-color-button-secondary-danger-inverse-content-disabled: #6c6c6c;
  --cre8-color-button-secondary-danger-border: #d02525;
  --cre8-color-button-secondary-danger-inverse-border: #ff5c5c;
  --cre8-color-button-secondary-danger-border-hover: #aa1313;
  --cre8-color-button-secondary-danger-inverse-border-hover: #f5a8a8;
  --cre8-color-button-secondary-danger-border-active: #7a0000;
  --cre8-color-button-secondary-danger-inverse-border-active: #fccaca;
  --cre8-color-button-secondary-danger-border-disabled: #eaeaea;
  --cre8-color-button-secondary-danger-inverse-border-disabled: #ababab;
  --cre8-color-button-secondary-danger-outline: #0a3d8f;
  --cre8-color-button-secondary-danger-inverse-outline: #e8eaf6;
  --cre8-color-button-tertiary-bg: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-inverse-bg: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-bg-hover: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-inverse-bg-hover: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-bg-active: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-inverse-bg-active: #1565c0;
  --cre8-color-button-tertiary-bg-disabled: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-inverse-bg-disabled: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-content: #1a73e8;
  --cre8-color-button-tertiary-inverse-content: #e8eaf6;
  --cre8-color-button-tertiary-content-hover: #0d47a1;
  --cre8-color-button-tertiary-inverse-content-hover: #c5cae9;
  --cre8-color-button-tertiary-content-active: #0a3d8f;
  --cre8-color-button-tertiary-inverse-content-active: #9fa8da;
  --cre8-color-button-tertiary-content-disabled: #949494;
  --cre8-color-button-tertiary-inverse-content-disabled: #ababab;
  --cre8-color-button-tertiary-border: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-inverse-border: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-border-hover: #0d47a1;
  --cre8-color-button-tertiary-inverse-border-hover: #c5cae9;
  --cre8-color-button-tertiary-border-active: #0a3d8f;
  --cre8-color-button-tertiary-inverse-border-active: #9fa8da;
  --cre8-color-button-tertiary-border-disabled: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-inverse-border-disabled: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-outline: #0a3d8f;
  --cre8-color-button-tertiary-inverse-outline: #c5cae9;
  --cre8-color-button-tertiary-neutral-bg: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-neutral-inverse-bg: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-neutral-content: #2d2d2d;
  --cre8-color-button-tertiary-neutral-inverse-content: #ffffff;
  --cre8-color-button-tertiary-neutral-border: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-neutral-inverse-border: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-neutral-bg-hover: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-neutral-inverse-bg-hover: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-neutral-content-hover: #2d2d2d;
  --cre8-color-button-tertiary-neutral-inverse-content-hover: #ffffff;
  --cre8-color-button-tertiary-neutral-border-hover: #2d2d2d;
  --cre8-color-button-tertiary-neutral-inverse-border-hover: #ffffff;
  --cre8-color-button-tertiary-neutral-border-active: #2d2d2d;
  --cre8-color-button-tertiary-neutral-inverse-border-active: #ffffff;
  --cre8-color-button-tertiary-neutral-bg-active: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-neutral-inverse-bg-active: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-neutral-content-active: #2d2d2d;
  --cre8-color-button-tertiary-neutral-inverse-content-active: #ffffff;
  --cre8-color-button-tertiary-neutral-bg-disabled: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-neutral-inverse-bg-disabled: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-neutral-border-disabled: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-neutral-inverse-border-disabled: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-neutral-content-disabled: #949494;
  --cre8-color-button-tertiary-neutral-inverse-content-disabled: #6c6c6c;
  --cre8-color-button-tertiary-danger-bg: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-danger-inverse-bg: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-danger-bg-hover: #aa1313;
  --cre8-color-button-tertiary-danger-inverse-bg-hover: #f5a8a8;
  --cre8-color-button-tertiary-danger-bg-active: #7a0000;
  --cre8-color-button-tertiary-danger-inverse-bg-active: #fccaca;
  --cre8-color-button-tertiary-danger-bg-disabled: #eaeaea;
  --cre8-color-button-tertiary-danger-inverse-bg-disabled: #ababab;
  --cre8-color-button-tertiary-danger-content: #d02525;
  --cre8-color-button-tertiary-danger-inverse-content: #ff5c5c;
  --cre8-color-button-tertiary-danger-content-hover: #ffffff;
  --cre8-color-button-tertiary-danger-inverse-content-hover: #2d2d2d;
  --cre8-color-button-tertiary-danger-content-active: #ffffff;
  --cre8-color-button-tertiary-danger-inverse-content-active: #2d2d2d;
  --cre8-color-button-tertiary-danger-content-disabled: #949494;
  --cre8-color-button-tertiary-danger-inverse-content-disabled: #6c6c6c;
  --cre8-color-button-tertiary-danger-border: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-danger-inverse-border: rgba(45, 45, 45, 0.0);
  --cre8-color-button-tertiary-danger-border-hover: #aa1313;
  --cre8-color-button-tertiary-danger-inverse-border-hover: #f5a8a8;
  --cre8-color-button-tertiary-danger-border-active: #7a0000;
  --cre8-color-button-tertiary-danger-inverse-border-active: #fccaca;
  --cre8-color-button-tertiary-danger-border-disabled: #eaeaea;
  --cre8-color-button-tertiary-danger-inverse-border-disabled: #ababab;
  --cre8-color-bg-default: #ffffff;
  --cre8-color-bg-default-hover: #ffffff;
  --cre8-color-bg-default-active: #e3f2fd;
  --cre8-color-bg-subtle: #f6f5f3;
  --cre8-color-bg-moderate: #818181;
  --cre8-color-bg-inverse-moderate: #ababab;
  --cre8-color-bg-strong: #2d2d2d;
  --cre8-color-bg-disabled: #eaeaea;
  --cre8-color-bg-brand: #ffffff;
  --cre8-color-bg-brand-active: #bbdefb;
  --cre8-color-bg-brand-hover: #e3f2fd;
  --cre8-color-bg-brand-strong: #1a73e8;
  --cre8-color-bg-brand-strong-hover: #0d47a1;
  --cre8-color-bg-brand-strong-active: #0a3d8f;
  --cre8-color-bg-brand-xstrong: #0d47a1;
  --cre8-color-bg-brand-xstrong-hover: #0a3d8f;
  --cre8-color-bg-brand-xstrong-active: #0a3d8f;
  --cre8-color-bg-success: #e8eaf6;
  --cre8-color-bg-success-strong: #3949ab;
  --cre8-color-bg-error: #ffebeb;
  --cre8-color-bg-error-strong: #d02525;
  --cre8-color-bg-warning: #fcf5e5;
  --cre8-color-bg-warning-strong: #e89f12;
  --cre8-color-bg-info: #ebf2ff;
  --cre8-color-bg-info-strong: #1963e1;
  --cre8-color-bg-attention: #ffffff;
  --cre8-color-bg-attention-strong: #42a5f5;
  --cre8-color-bg-opacity-transparent: rgba(45, 45, 45, 0.0);
  --cre8-color-bg-opacity-default: rgba(45, 45, 45, 0.50);
  --cre8-color-bg-active: #2d2d2d;
  --cre8-color-bg-inverse-active: #ffffff;
  --cre8-color-content-default: #2d2d2d;
  --cre8-color-content-subtle: #6c6c6c;
  --cre8-color-content-disabled: #949494;
  --cre8-color-content-knockout: #ffffff;
  --cre8-color-content-brand: #1a73e8;
  --cre8-color-content-brand-strong: #1a73e8;
  --cre8-color-content-brand-knockout: #e8eaf6;
  --cre8-color-content-success: #3949ab;
  --cre8-color-content-success-icon: #3949ab;
  --cre8-color-content-error: #d02525;
  --cre8-color-content-error-icon: #d02525;
  --cre8-color-content-warning-icon: #2d2d2d;
  --cre8-color-content-info-icon: #1963e1;
  --cre8-color-content-attention-icon: #42a5f5;
  --cre8-color-content-link: #1a73e8;
  --cre8-color-content-inverse-link: #e8eaf6;
  --cre8-color-content-link-hover: #0d47a1;
  --cre8-color-content-inverse-link-hover: #c5cae9;
  --cre8-color-content-link-focus: #ffffff;
  --cre8-color-content-inverse-link-focus: #2d2d2d;
  --cre8-color-content-link-visited: #7522d9;
  --cre8-color-content-inverse-link-visited: #ecc8e4;
  --cre8-color-content-link-disabled: #949494;
  --cre8-color-content-inverse-link-disabled: #eaeaea;
  --cre8-color-content-link-active: #0a3d8f;
  --cre8-color-content-inverse-link-active: #9fa8da;
  --cre8-color-border-default: #d5d5d5;
  --cre8-color-border-strong: #6c6c6c;
  --cre8-color-border-knockout: #ffffff;
  --cre8-color-border-disabled: #ababab;
  --cre8-color-border-brand: #1a73e8;
  --cre8-color-border-brand-subtle: #90caf9;
  --cre8-color-border-brand-strong: #1a73e8;
  --cre8-color-border-success: #5c6bc0;
  --cre8-color-border-error: #e93a3a;
  --cre8-color-border-warning: #e89f12;
  --cre8-color-border-info: #1963e1;
  --cre8-color-border-attention: #42a5f5;
  --cre8-color-border-transparent: rgba(45, 45, 45, 0.0);
  --cre8-color-border-active-outline: #0d47a1;
  --cre8-color-border-inverse-active-outline: #e8eaf6;
  --cre8-font-size-0: 0.75rem;
  --cre8-font-size-1: 0.875rem;
  --cre8-font-size-2: 1rem;
  --cre8-font-size-3: 1.125rem;
  --cre8-font-size-4: 1.25rem;
  --cre8-font-size-5: 1.5rem;
  --cre8-font-size-6: 1.75rem;
  --cre8-font-size-7: 2rem;
  --cre8-font-size-8: 2.5rem;
  --cre8-font-size-9: 3rem;
  --cre8-font-size-10: 3.5rem;
  --cre8-font-size-11: 4rem;
  --cre8-font-size-12: 4.5rem;
  --cre8-font-size-13: 5rem;
  --cre8-letter-spacing-0: -1.5;
  --cre8-letter-spacing-1: -1;
  --cre8-letter-spacing-2: -0.5;
  --cre8-letter-spacing-3: 0;
  --cre8-letter-spacing-4: 2;
  --cre8-letter-spacing-5: 1;
  --cre8-letter-spacing-6: 1.5;
  --cre8-paragraph-spacing-0: 0;
  --cre8-text-case-none: none;
  --cre8-text-case-uppercase: uppercase;
  --cre8-text-decoration-none: none;
  --cre8-text-decoration-underline: underline;
  --cre8-paragraph-indent-0: 0px;
  --cre8-border-radius-small: 4px;
  --cre8-border-radius-default: 8px;
  --cre8-border-radius-large: 16px;
  --cre8-border-radius-round: 900px;
  --cre8-border-radius-button: 8px;
  --cre8-border-radius-badge: 4px;
  --cre8-border-radius-tabs: 8px;
  --cre8-border-radius-container: 16px;
  --cre8-border-radius-field: 8px;
  --cre8-border-radius-field-brand: 8px;
  --cre8-border-radius-brand: 8px;
  --cre8-border-radius-none: 0px;
  --cre8-border-width-none: 0rem;
  --cre8-border-width-default: 0.0625rem;
  --cre8-border-width-focus: 0.125rem;
  --cre8-border-width-large: 0.25rem;
  --cre8-border-width-button-tertiary-outline-focus: 0.125rem;
  --cre8-border-width-button-default: 0.125rem;
  --cre8-border-width-tab-selected: 0.125rem;
  --cre8-border-width-tab-default: 0.125rem;
  --cre8-border-style-button-tertiary-outline-focus: solid;
  --cre8-border-style-default: solid;
  --cre8-shadow-default: 0 8px 6px 0 rgba(0,0,0,0.1);
  --cre8-shadow-button: none;
  --cre8-shadow-none: none;
  --cre8-shadow-large: 0 10px 12px 0 rgba(0,0,0,0.2);
  --cre8-shadow-small: 0 1px 2px 1px rgba(0,0,0,0.2);
  --cre8-color-link-bg-active: #333333;
  --cre8-font-families-inter: "Inter", sans-serif;
  --cre8-font-weights-inter-0: 400;
  --cre8-font-weights-inter-1: 500;
  --cre8-font-weights-inter-2: 700;
  --cre8-font-weights-inter-3: 600;
  --cre8-line-heights-0: 1.25;
  --cre8-line-heights-1: 1.12;
  --cre8-line-heights-2: 1.1400000000000001;
  --cre8-line-heights-3: 1.2;
  --cre8-line-heights-4: 1.3;
  --cre8-line-heights-5: 1.33;
  --cre8-line-heights-6: 1.4000000000000001;
  --cre8-line-heights-7: 1.5;
  --cre8-line-heights-8: 1.43;
  --cre8-line-heights-9: 1.11;
  --cre8-line-heights-10: 1.1300000000000001;
  --cre8-line-heights-11: 1.16;
  --cre8-line-heights-12: 0.48;
  --cre8-line-heights-13: 0.4;
  --cre8-line-heights-14: 0.32;
  --cre8-line-heights-15: 0.28;
  --cre8-line-heights-16: 0.24;
  --cre8-line-heights-17: 0.2;
  --cre8-line-heights-18: 0.16;
  --cre8-icon-size-small: 0.875rem;
  --cre8-icon-size-default: 1rem;
  --cre8-icon-size-large: 1.125rem;
  --cre8-badge-padding-horizontal: 0.375rem;
  --cre8-badge-padding-vertical: 0.125rem;
  --cre8-progress-meter-height: 0.5rem;
  --cre8-breakpoint-xsm: 375px;
  --cre8-breakpoint-sm: 560px;
  --cre8-breakpoint-md: 768px;
  --cre8-breakpoint-lg: 960px;
  --cre8-breakpoint-xl: 1200px;
  --cre8-breakpoint-xxl: 1400px;
  --cre8-typography-body-xlarge-font-family: var(--cre8-font-families-inter);
  --cre8-typography-body-xlarge-font-size: var(--cre8-font-size-5);
  --cre8-typography-body-xlarge-font-weight: var(--cre8-font-weights-inter-0);
  --cre8-typography-body-xlarge-line-height: var(--cre8-line-heights-7);
  --cre8-typography-body-xlarge-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-body-xlarge-text-transform: var(--cre8-text-case-none);
  --cre8-typography-body-xlarge-strong-font-family: var(--cre8-font-families-inter);
  --cre8-typography-body-xlarge-strong-font-size: var(--cre8-font-size-5);
  --cre8-typography-body-xlarge-strong-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-body-xlarge-strong-line-height: var(--cre8-line-heights-7);
  --cre8-typography-body-xlarge-strong-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-body-xlarge-strong-text-transform: var(--cre8-text-case-none);
  --cre8-typography-body-xlarge-link-font-family: var(--cre8-font-families-inter);
  --cre8-typography-body-xlarge-link-font-size: var(--cre8-font-size-5);
  --cre8-typography-body-xlarge-link-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-body-xlarge-link-line-height: var(--cre8-line-heights-7);
  --cre8-typography-body-xlarge-link-text-decoration: var(--cre8-text-decoration-underline);
  --cre8-typography-body-xlarge-link-text-transform: var(--cre8-text-case-none);
  --cre8-typography-body-large-font-family: var(--cre8-font-families-inter);
  --cre8-typography-body-large-font-size: var(--cre8-font-size-3);
  --cre8-typography-body-large-font-weight: var(--cre8-font-weights-inter-0);
  --cre8-typography-body-large-line-height: var(--cre8-line-heights-7);
  --cre8-typography-body-large-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-body-large-text-transform: var(--cre8-text-case-none);
  --cre8-typography-body-large-strong-font-family: var(--cre8-font-families-inter);
  --cre8-typography-body-large-strong-font-size: var(--cre8-font-size-3);
  --cre8-typography-body-large-strong-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-body-large-strong-line-height: var(--cre8-line-heights-7);
  --cre8-typography-body-large-strong-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-body-large-strong-text-transform: var(--cre8-text-case-none);
  --cre8-typography-body-default-font-family: var(--cre8-font-families-inter);
  --cre8-typography-body-default-font-size: var(--cre8-font-size-2);
  --cre8-typography-body-default-font-weight: var(--cre8-font-weights-inter-0);
  --cre8-typography-body-default-line-height: var(--cre8-line-heights-7);
  --cre8-typography-body-default-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-body-default-text-transform: var(--cre8-text-case-none);
  --cre8-typography-body-default-strong-font-family: var(--cre8-font-families-inter);
  --cre8-typography-body-default-strong-font-size: var(--cre8-font-size-2);
  --cre8-typography-body-default-strong-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-body-default-strong-line-height: var(--cre8-line-heights-7);
  --cre8-typography-body-default-strong-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-body-default-strong-text-transform: var(--cre8-text-case-none);
  --cre8-typography-body-small-font-family: var(--cre8-font-families-inter);
  --cre8-typography-body-small-font-size: var(--cre8-font-size-1);
  --cre8-typography-body-small-font-weight: var(--cre8-font-weights-inter-0);
  --cre8-typography-body-small-line-height: var(--cre8-line-heights-8);
  --cre8-typography-body-small-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-body-small-text-transform: var(--cre8-text-case-none);
  --cre8-typography-body-small-strong-font-family: var(--cre8-font-families-inter);
  --cre8-typography-body-small-strong-font-size: var(--cre8-font-size-1);
  --cre8-typography-body-small-strong-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-body-small-strong-line-height: var(--cre8-line-heights-8);
  --cre8-typography-body-small-strong-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-body-small-strong-text-transform: var(--cre8-text-case-none);
  --cre8-typography-body-large-link-font-family: var(--cre8-font-families-inter);
  --cre8-typography-body-large-link-font-size: var(--cre8-font-size-3);
  --cre8-typography-body-large-link-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-body-large-link-line-height: var(--cre8-line-heights-7);
  --cre8-typography-body-large-link-text-decoration: var(--cre8-text-decoration-underline);
  --cre8-typography-body-large-link-text-transform: var(--cre8-text-case-none);
  --cre8-typography-body-default-link-font-family: var(--cre8-font-families-inter);
  --cre8-typography-body-default-link-font-size: var(--cre8-font-size-2);
  --cre8-typography-body-default-link-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-body-default-link-line-height: var(--cre8-line-heights-7);
  --cre8-typography-body-default-link-text-decoration: var(--cre8-text-decoration-underline);
  --cre8-typography-body-default-link-text-transform: var(--cre8-text-case-none);
  --cre8-typography-body-small-link-font-family: var(--cre8-font-families-inter);
  --cre8-typography-body-small-link-font-size: var(--cre8-font-size-1);
  --cre8-typography-body-small-link-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-body-small-link-line-height: var(--cre8-line-heights-8);
  --cre8-typography-body-small-link-text-decoration: var(--cre8-text-decoration-underline);
  --cre8-typography-body-small-link-text-transform: var(--cre8-text-case-none);
  --cre8-typography-label-default-font-family: var(--cre8-font-families-inter);
  --cre8-typography-label-default-font-size: var(--cre8-font-size-2);
  --cre8-typography-label-default-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-label-default-line-height: var(--cre8-line-heights-7);
  --cre8-typography-label-default-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-label-default-text-transform: var(--cre8-text-case-none);
  --cre8-typography-label-large-font-family: var(--cre8-font-families-inter);
  --cre8-typography-label-large-font-size: var(--cre8-font-size-3);
  --cre8-typography-label-large-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-label-large-line-height: var(--cre8-line-heights-5);
  --cre8-typography-label-large-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-label-large-text-transform: var(--cre8-text-case-none);
  --cre8-typography-label-small-font-family: var(--cre8-font-families-inter);
  --cre8-typography-label-small-font-size: var(--cre8-font-size-1);
  --cre8-typography-label-small-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-label-small-line-height: var(--cre8-line-heights-7);
  --cre8-typography-label-small-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-label-small-text-transform: var(--cre8-text-case-none);
  --cre8-typography-title-xlarge-font-family: var(--cre8-font-families-inter);
  --cre8-typography-title-xlarge-font-size: var(--cre8-font-size-8);
  --cre8-typography-title-xlarge-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-title-xlarge-line-height: var(--cre8-line-heights-4);
  --cre8-typography-title-xlarge-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-title-xlarge-text-transform: var(--cre8-text-case-none);
  --cre8-typography-title-xlarge-mobile-font-family: var(--cre8-font-families-inter);
  --cre8-typography-title-xlarge-mobile-font-size: var(--cre8-font-size-7);
  --cre8-typography-title-xlarge-mobile-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-title-xlarge-mobile-line-height: var(--cre8-line-heights-4);
  --cre8-typography-title-xlarge-mobile-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-title-xlarge-mobile-text-transform: var(--cre8-text-case-none);
  --cre8-typography-title-large-font-family: var(--cre8-font-families-inter);
  --cre8-typography-title-large-font-size: var(--cre8-font-size-6);
  --cre8-typography-title-large-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-title-large-line-height: var(--cre8-line-heights-1);
  --cre8-typography-title-large-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-title-large-text-transform: var(--cre8-text-case-none);
  --cre8-typography-title-large-mobile-font-family: var(--cre8-font-families-inter);
  --cre8-typography-title-large-mobile-font-size: var(--cre8-font-size-5);
  --cre8-typography-title-large-mobile-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-title-large-mobile-line-height: var(--cre8-line-heights-1);
  --cre8-typography-title-large-mobile-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-title-large-mobile-text-transform: var(--cre8-text-case-none);
  --cre8-typography-title-default-font-family: var(--cre8-font-families-inter);
  --cre8-typography-title-default-font-size: var(--cre8-font-size-5);
  --cre8-typography-title-default-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-title-default-line-height: var(--cre8-line-heights-2);
  --cre8-typography-title-default-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-title-default-text-transform: var(--cre8-text-case-none);
  --cre8-typography-title-default-mobile-font-family: var(--cre8-font-families-inter);
  --cre8-typography-title-default-mobile-font-size: var(--cre8-font-size-3);
  --cre8-typography-title-default-mobile-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-title-default-mobile-line-height: var(--cre8-line-heights-2);
  --cre8-typography-title-default-mobile-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-title-default-mobile-text-transform: var(--cre8-text-case-none);
  --cre8-typography-title-small-font-family: var(--cre8-font-families-inter);
  --cre8-typography-title-small-font-size: var(--cre8-font-size-3);
  --cre8-typography-title-small-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-title-small-line-height: var(--cre8-line-heights-6);
  --cre8-typography-title-small-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-title-small-text-transform: var(--cre8-text-case-none);
  --cre8-typography-title-small-mobile-font-family: var(--cre8-font-families-inter);
  --cre8-typography-title-small-mobile-font-size: var(--cre8-font-size-2);
  --cre8-typography-title-small-mobile-font-weight: var(--cre8-font-weights-inter-1);
  --cre8-typography-title-small-mobile-line-height: var(--cre8-line-heights-6);
  --cre8-typography-title-small-mobile-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-title-small-mobile-text-transform: var(--cre8-text-case-none);
  --cre8-typography-headline-large-font-family: var(--cre8-font-families-inter);
  --cre8-typography-headline-large-font-size: var(--cre8-font-size-9);
  --cre8-typography-headline-large-font-weight: var(--cre8-font-weights-inter-3);
  --cre8-typography-headline-large-line-height: var(--cre8-line-heights-0);
  --cre8-typography-headline-large-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-headline-large-text-transform: var(--cre8-text-case-none);
  --cre8-typography-headline-large-mobile-font-family: var(--cre8-font-families-inter);
  --cre8-typography-headline-large-mobile-font-size: var(--cre8-font-size-8);
  --cre8-typography-headline-large-mobile-font-weight: var(--cre8-font-weights-inter-3);
  --cre8-typography-headline-large-mobile-line-height: var(--cre8-line-heights-0);
  --cre8-typography-headline-large-mobile-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-headline-large-mobile-text-transform: var(--cre8-text-case-none);
  --cre8-typography-headline-default-font-family: var(--cre8-font-families-inter);
  --cre8-typography-headline-default-font-size: var(--cre8-font-size-8);
  --cre8-typography-headline-default-font-weight: var(--cre8-font-weights-inter-3);
  --cre8-typography-headline-default-line-height: var(--cre8-line-heights-0);
  --cre8-typography-headline-default-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-headline-default-text-transform: var(--cre8-text-case-none);
  --cre8-typography-headline-default-mobile-font-family: var(--cre8-font-families-inter);
  --cre8-typography-headline-default-mobile-font-size: var(--cre8-font-size-7);
  --cre8-typography-headline-default-mobile-font-weight: var(--cre8-font-weights-inter-3);
  --cre8-typography-headline-default-mobile-line-height: var(--cre8-line-heights-0);
  --cre8-typography-headline-default-mobile-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-headline-default-mobile-text-transform: var(--cre8-text-case-none);
  --cre8-typography-headline-small-font-family: var(--cre8-font-families-inter);
  --cre8-typography-headline-small-font-size: var(--cre8-font-size-7);
  --cre8-typography-headline-small-font-weight: var(--cre8-font-weights-inter-3);
  --cre8-typography-headline-small-line-height: var(--cre8-line-heights-0);
  --cre8-typography-headline-small-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-headline-small-text-transform: var(--cre8-text-case-none);
  --cre8-typography-headline-small-mobile-font-family: var(--cre8-font-families-inter);
  --cre8-typography-headline-small-mobile-font-size: var(--cre8-font-size-6);
  --cre8-typography-headline-small-mobile-font-weight: var(--cre8-font-weights-inter-3);
  --cre8-typography-headline-small-mobile-line-height: var(--cre8-line-heights-0);
  --cre8-typography-headline-small-mobile-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-headline-small-mobile-text-transform: var(--cre8-text-case-none);
  --cre8-typography-headline-xsmall-font-family: var(--cre8-font-families-inter);
  --cre8-typography-headline-xsmall-font-size: var(--cre8-font-size-5);
  --cre8-typography-headline-xsmall-font-weight: var(--cre8-font-weights-inter-3);
  --cre8-typography-headline-xsmall-line-height: var(--cre8-line-heights-0);
  --cre8-typography-headline-xsmall-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-headline-xsmall-text-transform: var(--cre8-text-case-none);
  --cre8-typography-headline-xsmall-mobile-font-family: var(--cre8-font-families-inter);
  --cre8-typography-headline-xsmall-mobile-font-size: var(--cre8-font-size-5);
  --cre8-typography-headline-xsmall-mobile-font-weight: var(--cre8-font-weights-inter-3);
  --cre8-typography-headline-xsmall-mobile-line-height: var(--cre8-line-heights-0);
  --cre8-typography-headline-xsmall-mobile-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-headline-xsmall-mobile-text-transform: var(--cre8-text-case-none);
  --cre8-typography-display-large-font-family: var(--cre8-font-families-inter);
  --cre8-typography-display-large-font-size: var(--cre8-font-size-13);
  --cre8-typography-display-large-font-weight: var(--cre8-font-weights-inter-2);
  --cre8-typography-display-large-line-height: var(--cre8-line-heights-0);
  --cre8-typography-display-large-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-display-large-text-transform: var(--cre8-text-case-none);
  --cre8-typography-display-large-mobile-font-family: var(--cre8-font-families-inter);
  --cre8-typography-display-large-mobile-font-size: var(--cre8-font-size-12);
  --cre8-typography-display-large-mobile-font-weight: var(--cre8-font-weights-inter-2);
  --cre8-typography-display-large-mobile-line-height: var(--cre8-line-heights-0);
  --cre8-typography-display-large-mobile-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-display-large-mobile-text-transform: var(--cre8-text-case-none);
  --cre8-typography-display-default-font-family: var(--cre8-font-families-inter);
  --cre8-typography-display-default-font-size: var(--cre8-font-size-11);
  --cre8-typography-display-default-font-weight: var(--cre8-font-weights-inter-2);
  --cre8-typography-display-default-line-height: var(--cre8-line-heights-0);
  --cre8-typography-display-default-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-display-default-text-transform: var(--cre8-text-case-none);
  --cre8-typography-display-default-mobile-font-family: var(--cre8-font-families-inter);
  --cre8-typography-display-default-mobile-font-size: var(--cre8-font-size-10);
  --cre8-typography-display-default-mobile-font-weight: var(--cre8-font-weights-inter-2);
  --cre8-typography-display-default-mobile-line-height: var(--cre8-line-heights-0);
  --cre8-typography-display-default-mobile-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-display-default-mobile-text-transform: var(--cre8-text-case-none);
  --cre8-typography-display-small-font-family: var(--cre8-font-families-inter);
  --cre8-typography-display-small-font-size: var(--cre8-font-size-9);
  --cre8-typography-display-small-font-weight: var(--cre8-font-weights-inter-2);
  --cre8-typography-display-small-line-height: var(--cre8-line-heights-0);
  --cre8-typography-display-small-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-display-small-text-transform: var(--cre8-text-case-none);
  --cre8-typography-display-small-mobile-font-family: var(--cre8-font-families-inter);
  --cre8-typography-display-small-mobile-font-size: var(--cre8-font-size-8);
  --cre8-typography-display-small-mobile-font-weight: var(--cre8-font-weights-inter-2);
  --cre8-typography-display-small-mobile-line-height: var(--cre8-line-heights-0);
  --cre8-typography-display-small-mobile-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-display-small-mobile-text-transform: var(--cre8-text-case-none);
  --cre8-typography-meta-default-font-family: var(--cre8-font-families-inter);
  --cre8-typography-meta-default-font-size: var(--cre8-font-size-2);
  --cre8-typography-meta-default-font-weight: var(--cre8-font-weights-inter-2);
  --cre8-typography-meta-default-line-height: var(--cre8-line-heights-3);
  --cre8-typography-meta-default-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-meta-default-text-transform: var(--cre8-text-case-uppercase);
  --cre8-typography-meta-default-sentence-case-font-family: var(--cre8-font-families-inter);
  --cre8-typography-meta-default-sentence-case-font-size: var(--cre8-font-size-2);
  --cre8-typography-meta-default-sentence-case-font-weight: var(--cre8-font-weights-inter-2);
  --cre8-typography-meta-default-sentence-case-line-height: var(--cre8-line-heights-11);
  --cre8-typography-meta-default-sentence-case-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-meta-default-sentence-case-text-transform: var(--cre8-text-case-none);
  --cre8-typography-meta-large-font-family: var(--cre8-font-families-inter);
  --cre8-typography-meta-large-font-size: var(--cre8-font-size-4);
  --cre8-typography-meta-large-font-weight: var(--cre8-font-weights-inter-2);
  --cre8-typography-meta-large-line-height: var(--cre8-line-heights-3);
  --cre8-typography-meta-large-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-meta-large-text-transform: var(--cre8-text-case-uppercase);
  --cre8-typography-meta-small-font-family: var(--cre8-font-families-inter);
  --cre8-typography-meta-small-font-size: var(--cre8-font-size-1);
  --cre8-typography-meta-small-font-weight: var(--cre8-font-weights-inter-2);
  --cre8-typography-meta-small-line-height: var(--cre8-line-heights-3);
  --cre8-typography-meta-small-text-decoration: var(--cre8-text-decoration-none);
  --cre8-typography-meta-small-text-transform: var(--cre8-text-case-uppercase);
}
`;

export default blue;
